import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

@Component({
  imports: [RouterModule, MatIconModule],
  selector: 'norupe-app-unauthorized-menu',
  styles: ``,
  templateUrl: './unauthorized-menu.component.html',
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class UnauthorizedMenuComponent {}
